<template>
    <el-breadcrumb separator="/" class="bread-crumb main">
         <el-breadcrumb-item v-for="(item,index) in breadList" :key="index">
             <!-- <router-link v-if="item.path" :to="{path:item.path}">{{item.meta.title}}</router-link> -->
             <router-link v-if="item.path" :to="{path:item.path}" @click.native="save(item.path)">{{item.meta.title}}</router-link>
                <a v-else>
                    {{item.meta.title}}
                </a>
         </el-breadcrumb-item>
    </el-breadcrumb>
</template>
<script>
export default {
    data(){
        return{
            breadList:[]
        }
    },
    watch:{
        $route(to,from) {
            this.getBreadcrumb();
        }
    },
    beforeRouteEnter(to, from, next) {
        const meta = to.meta;
        next();
    },
    beforeRouteUpdata(to,from,next) {
        
    },
    methods:{
        save(path){
            if(path === "/news") {
                sessionStorage.pageNumber = 0
            }
        },
        isNewsHome(route) {
            return route.name === "news"
        },
        getBreadcrumb() {
            let matched = this.$route.matched;
            // console.log(matched);
             // console.log(this.$route.matched);
             //如果不是首页
            //  if (!this.isNewsHome(matched[0])) {
            matched = [{ path: "/news", meta: { title: "新闻首页" } }].concat(matched);
            //  }  
            this.breadList = matched;

             for(let i = 0; i<this.breadList.length; i++) {
                if(!this.breadList[i].meta.title) {
                    this.breadList.splice(i,1);
                }
             }
        },
    },
    created() {
        this.getBreadcrumb();
    },
    mounted(){
    }
}
</script>

<style lang="less" scoped>
    .main {
        width: 1200px;
        margin: 0 auto;
    }

    .bread-crumb {
        box-sizing: border-box;
        padding-left: 20px;
        line-height: 55px;
        background-color: transparent;
     }
</style>